module.exports = __webpack_public_path__ + "img/tiktok.41bc8e18.svg";